module.exports = __webpack_public_path__ + "bff8564efb7d33af1ec2fd7f8f760832.pdf";